<template>
  <div class="more_button" :class="show ? 'active' : ''" @click="toggleModal()"></div>
  <div class="more_contents" v-if="show" v-click-outside="closeModal">
    <div class="block" @click.stop="addBlockUser()">
      <button type="button" :class="{ 'disabled': isDisabled }">このユーザーをブロック</button>
    </div>
    <div class="block" @click.stop="reportContent()">
      <button type="button" :class="{ 'disabled': isDisabled }">この投稿を通報</button>
    </div>
  </div>
  <div v-show="completeFlag" class="form modal completeModal formSignupAppeal" v-click-outside="closeCompleteModal">
    <div class="box">
      <div class="contents">
        <div class="complete">
          <div class="icon"></div>
          <h3>{{ message }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
export default {
  props: {
    userId: Number,
    contentType: Number,
    contentId: Number
  },
  data() {
    return {
      params: {
        user_id: null,
        content_type: null,
        content_id: null
      },
      show: false,
      completeFlag: false,
      isDisabled: false,
      message: 'コンテンツを報告しました'
    }
  },
  methods: {
    closeModal() {
      this.show = false
    },
    closeCompleteModal() {
      if (this.completeFlag) {
        location.reload()
      }
    },
    toggleModal() {
      if (this.show) {
        this.show = false
      } else {
        this.show = true
      }
    },
    async addBlockUser() {
      this.isDisabled = true
      this.params.user_id = this.userId
      // アカウントブロックAPI
      await axios.post('/api/users/account/block', this.params).then(res => {
        if (res.data.success) {
          this.message = 'アカウントをブロックしました'
          this.completeFlag = true
          this.isDisabled = false

          setTimeout(function () {
            location.reload()
          }, 2000)

        } else {
          console.log(res.data.errors)
          this.errors = res.data.errors
          this.isDisabled = false
        }
      }).catch(e => {
        console.log('Error', e)
      })
    },
    async reportContent() {
      this.isDisabled = true
      this.params = {
        content_type: this.contentType,
        content_id: this.contentId
      }
      // コンテンツ通報API
      await axios.post('/api/users/report/content', this.params).then(res => {
        if (res.data.success) {
          this.message = 'コンテンツを報告しました'
          this.completeFlag = true
          this.isDisabled = false

          setTimeout(function () {
            location.reload()
          }, 2000)

        } else {
          console.log(res.data.errors)
          this.errors = res.data.errors
          this.isDisabled = false
        }
      }).catch(e => {
        console.log('Error', e)
      })
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  watch: {
    show(val) {
      if (!val) return
    }
  }
}
</script>
